import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {AppConfigurationService} from '../shared/app-configuration.service';
import {map, Observable} from 'rxjs';
import {HorizonStudent} from '@model/horizon-student';
import {EleveHorizonDto, EleveHorizonDtoMapper} from './dto/eleveHorizonDto';
import { SearchData } from '@model/search-data';
import { HorizonPage } from '@model/page';

@Injectable({
  providedIn: 'root'
})
export class HorizonStudentService {
  private readonly _apiUrl: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigurationService) {
    this._apiUrl = `${this._appConfig.getConfig().apiUrls.student}`;
  }

  getHorizonStudent(fasePO: number, studentHorizonId: string, currentSchoolYear: number): Observable<HorizonStudent> {
    return this._http.get<EleveHorizonDto>(`${this._apiUrl}/pouvoirsOrganisateurs/${fasePO}/eleves/${studentHorizonId}`).pipe(
      map(dto => EleveHorizonDtoMapper.toDomain(dto, currentSchoolYear))
    );
  }

  getHorizonStudents(fasePO: number, searchData: SearchData, currentSchoolYear: number): Observable<HorizonStudent[]> {
    let parameters: HttpParams = new HttpParams();
    if (searchData.filter) {
      parameters = parameters.set('q', searchData.filter);
    }
    if (searchData.pageNumber) {
      parameters = parameters.set('page', `${searchData.pageNumber}`);
    }
    if (searchData.pageSize) {
      parameters = parameters.set('pageSize', `${searchData.pageSize}`);
    }
    const headers = new HttpHeaders({'Accept':  'application/json'});
    return this._http.get<HorizonPage<EleveHorizonDto>>(`${this._apiUrl}/pouvoirsOrganisateurs/${fasePO}/eleves`, {params: parameters, headers: headers}).pipe(
      map(page => {
        return page.items.map(dto => EleveHorizonDtoMapper.toDomain(dto, currentSchoolYear));
      })
    );
  }
}
